/*FontAwesome library for icons*/
import AOS from 'aos'
import 'aos/dist/aos.css'

AOS.init();
